import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * <Breadcrumbs items={[{ label: "Members", to: "/admin/members" }, { label: "Jennifer Walsh" }]} />
 *
 * Last item (no `to`) is rendered as the current page in brand-teal.
 * Separator is a subtle chevron with reduced contrast.
 */
export function Breadcrumbs({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" className={`flex items-center gap-1.5 text-caption ${className}`} data-testid="breadcrumbs">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {item.to && !isLast ? (
              <Link to={item.to} className="text-ink-subtle hover:text-ink transition-colors">{item.label}</Link>
            ) : (
              <span className={isLast ? "text-brand-700 font-semibold" : "text-ink-subtle"}>{item.label}</span>
            )}
            {!isLast && <ChevronRight className="size-3 text-ink-hint" strokeWidth={2} />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
